export default "__VITE_ASSET__CHDRMSNP__"